export default "__VITE_ASSET__X6V7zxm2__"